import { __awaiter, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { getSearchCenterUrl } from '../search-center-url/getSearchCenterUrl';
/**
 * Call to warmup personal context call in 1JS
 */
export function warmupPersonalRankingContext(_a) {
    var searchPrefetch = _a.searchPrefetch, searchSettings = _a.searchSettings, searchHostAppLogger = _a.searchHostAppLogger;
    return __awaiter(this, void 0, void 0, function () {
        var _b, prefetch, tokenProviders, userEntitlements, clientId, searchCenterUrl, sharePointTokenProvider, sharePointResourceId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchPrefetch.getModule(),
                        searchSettings.getTokenProviders(),
                        searchSettings.getUserEntitlements(),
                        searchSettings.getHostAppId(),
                    ])];
                case 1:
                    _b = __read.apply(void 0, [_c.sent(), 4]), prefetch = _b[0], tokenProviders = _b[1], userEntitlements = _b[2], clientId = _b[3];
                    return [4 /*yield*/, getSearchCenterUrl(searchPrefetch, searchSettings, searchHostAppLogger)];
                case 2:
                    searchCenterUrl = _c.sent();
                    sharePointTokenProvider = tokenProviders.sharePointTokenProvider;
                    sharePointResourceId = (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.SharePointResourceId) || '';
                    return [2 /*return*/, queryCache.fetchQuery('SearchWarmupPersonalRakingContext', function () {
                            return prefetch.fetchPersonalRankingContext({
                                clientId: clientId,
                                tokenProvider: sharePointTokenProvider,
                                endpoint: "".concat(searchCenterUrl ? searchCenterUrl : sharePointResourceId, "/_api/search/query"),
                            });
                        }, {
                            cacheTime: Infinity,
                            staleTime: Infinity,
                        })];
            }
        });
    });
}
//# sourceMappingURL=warmupPersonalRankingContext.js.map